import type { JSX } from 'react';
import { Box } from '@mui/material';
import rwLogoSymbol from '@/assets/images/brand/rw-logo-symbol.svg';

export interface RwLogoMarkProps {
  size?: number;
  className?: string;
}

const LOGO_ASPECT_RATIO = 121 / 70;

export function RwLogoMark({ size = 24, className }: RwLogoMarkProps): JSX.Element {
  const height = size;
  const width = Math.round(size * LOGO_ASPECT_RATIO * 10) / 10;

  return <Box component="img" src={rwLogoSymbol} alt="" aria-hidden width={width} height={height} className={className} />;
}

export default RwLogoMark;
